// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getChildWidgetStyle(props, additionalStyle) {
    const style = props.config.style;
    if (style) {
        if (style.width != null ||
            style.paddingLeft != null ||
            style.paddingRight != null ||
            style.paddingTop != null ||
            style.paddingBottom != null) {
            return Object.assign(Object.assign({}, additionalStyle), { width: style.width, paddingLeft: style.paddingLeft, paddingRight: style.paddingRight, paddingTop: style.paddingTop, paddingBottom: style.paddingBottom });
        }
    }
    return additionalStyle;
}
